import { useEffect, useState } from "react";

import { supabase } from "~/integrations/supabase/client";
import { TransportData } from "~/types/dispatch";

// Loads the most recent transport data used on a guía de despacho for a client,
// so the create-guía form can prefill it (carrier/driver/plate usually repeat).
export function useLastTransportData(clientId: string | null | undefined) {
  const [data, setData] = useState<TransportData | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!clientId) {
      setData(null);
      return;
    }

    let cancelled = false;
    setIsLoading(true);

    (async () => {
      const { data: row } = await supabase
        .from("sales_request_documents")
        .select(
          "transport_driver_name, transport_driver_rut, transport_carrier_name, transport_carrier_rut, transport_vehicle_plate"
        )
        .eq("client_id", clientId)
        .eq("document_type", "guia_de_despacho")
        .not("transport_driver_name", "is", null)
        .is("deleted_at", null)
        .order("created_at", { ascending: false })
        .limit(1)
        .maybeSingle();

      if (cancelled) return;

      setData(
        row && row.transport_driver_name
          ? {
              driverName: row.transport_driver_name ?? "",
              driverRut: row.transport_driver_rut ?? "",
              carrierName: row.transport_carrier_name ?? "",
              carrierRut: row.transport_carrier_rut ?? "",
              vehiclePlate: row.transport_vehicle_plate ?? "",
            }
          : null
      );
      setIsLoading(false);
    })();

    return () => {
      cancelled = true;
    };
  }, [clientId]);

  return { data, isLoading };
}
